require("./apps/select-color");
require("./apps/fetch-property");
require("./apps/misc");
require("./apps/view-property");
require("./apps/owl-carousel-multi-row");
require("./apps/toggle-faq");
require("./apps/toggle-before-rent");
require("./apps/toggle-before-buy");
require("./apps/header");
require("./apps/fetch-latest-news");
